export default __webpack_public_path__ + "static/media/40.d19121a6.jpg";